import z from 'zod'

import { zh } from '@/libs/utils/zod'

export const ItemType = z.enum(['raw', 'semi'])
export type ItemType = z.infer<typeof ItemType>

export const ItemMasterDto = z.object({
  name: z.string(),
  desc: z.string(),
  img: z.string().nullish(),
  type: ItemType,
  categoryId: z.string().nullish(),
  baseCost: z.number(),
  units: z.array(
    z.object({
      code: z.string(),
      conv: z.number(),
      cost: z.number(),
    })
  ),
  outletIds: z.array(z.string()),
  recipeId: z.string().nullable(),
  ...zh.metadata.shape,
})

export type ItemMasterDto = z.infer<typeof ItemMasterDto>
